<template>
  <b-form v-on:submit.prevent="submit()" validated novalidate>
    <b-card>
      <div slot="header">
        {{title}}
      </div>
      <b-card-body>
        <b-form-group label-for="errName" label="Name">
          <b-form-input type="text" v-model="form.name" class="form-control-warning" id="errName" required></b-form-input>
          <b-form-valid-feedback>
            Valid name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter a Company Name.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="LandingPage" label="Landing Page">
          <b-form-select id="LandingPage"
                :options="landingPages"
                v-model="form.landingPage">
          </b-form-select>              
          <b-form-valid-feedback>
            Valid landing page provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Select landing page.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-card-body>
      <div slot="footer" class="text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/admin/companies/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-card>
  </b-form>
</template>
<script>
export default {
  name: 'formcompany',
  props: ['title','form'],
  computed: {
    landingPages () {
      return this.$store.state.landingPages;
    }
  },
  methods: {
    submit: function () {

      if(!this.form.name) {
        console.log('invalid')
        return
      }

      this.$emit('submit', this.form);
    }
  }
}
</script>
